export default "__VITE_ASSET__DGbwZSFT__"